import React, { Component } from "react";
import Global from "../../../Global";
import "./PromoSlider.css";

import ArrowLeftWhite from "../../../svgs/arrow-left-white.svg";
import ArrowRightWhite from "../../../svgs/arrow-right-white.svg";

class PromoSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sliderData: {},
      numOfSlide: 0,
    };
  }

  componentWillMount() {
    var url = Global.getAPI(this.props.urlAPI);
    var self = this;
    fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: promoslider");
        }
        return response.json();
      })
      .then(function(data) {
        self.setState(
          {
            sliderData: data.slider.items,
          },
          () => {
            window.THREE_MAIN.slider.init();
          }
        );
      });
  }

  getNumOfSlide() {
    return this.state.sliderData.length;
  }

  handleFacebookShare(event) {
    var shareUrl = event.currentTarget.getAttribute("data-share-link");
    if (shareUrl.length > 0 && shareUrl !== "null") {
      let fullUrl =
        "https://www.facebook.com/sharer/sharer.php?u=" +
        encodeURIComponent(shareUrl);
      window.open(fullUrl, "_blank", "height=626, width=436");
    }
  }

  handleHideOverlay(hideOverlay) {
    var className =
      hideOverlay === 1 ? "row promo-item hide-overlay" : "row promo-item";
    return className;
  }

  handleSliderClick(e) {
    var href = e.currentTarget.getAttribute("data-href");
    window.location.href = href;
  }

  getSliderHTML() {
    const { sliderData } = this.state;
    const filteredSliderData = sliderData.filter(
      (data) =>
        data.image !== "" &&
        data.imageMob !== "" &&
        data.ctaUrl !== "" &&
        data.title !== ""
    );
    return filteredSliderData.map((item, index) => {
      const { hideOverlay, ctaUrl, ctaText, imageMob, image, imageAlt } = item;

      return (
        <div
          key={index}
          className={this.handleHideOverlay(hideOverlay)}
          data-href={ctaUrl}
          onClick={(e) => {
            if (hideOverlay === 1) this.handleSliderClick(e);
          }}
        >
          <picture>
            <source media="(min-width:768px)" srcSet={encodeURI(image)} />
            <img
              loading="lazy"
              src={encodeURI(imageMob)}
              className="img-responsive"
              alt={imageAlt}
            />
          </picture>
          <div className="promo-box col-xs-11 col-xs-push-1 col-sm-8 col-sm-push-4 col-lg-6 col-lg-push-6">
            <div className="row">
              <div className="promo-cta col-xs-9 col-sm-4 col-md-5">
                <a className="btn btn-primary btn-fluid" href={ctaUrl}>
                  {ctaText}
                </a>
              </div>
              <div className="promo-slide-control col-xs-3 col-sm-8 col-md-7 hidden-xs">
                <a className="btn-prev" href={undefined}>
                  <img src="assets/images/icons/icon-arrow-left.png" alt="" />
                </a>
                <div className="dots-container" />
                <a className="btn-next" href={undefined}>
                  <img src="assets/images/icons/icon-arrow-right.png" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  renderDots() {
    return (
      <div className="dots-container">
        {[...Array(this.getNumOfSlide())].map((_, index) => {
          return (
            <div className="dot-container" data-slide-index={index}>
              <div
                className={`dot ${index == 0 ? "active" : ""}`}
                data-slide-index={index}
              />
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    if (Object.keys(this.state.sliderData).length === 0) {
      return false;
    } else {
      return (
        <section id="section-promos" className="section section-promos">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 promo-slider-wrapper">
                <div
                  id="hero-slider"
                  className="slider hero-slider"
                  data-slider-type="hero-slider"
                  data-slider-page={this.getNumOfSlide()}
                >
                  {this.getSliderHTML()}
                </div>
                <img
                  src={ArrowLeftWhite}
                  className={
                    this.getNumOfSlide() < 2
                      ? "slider-left hidden"
                      : "slider-left"
                  }
                />
                <img
                  src={ArrowRightWhite}
                  className={
                    this.getNumOfSlide() < 2
                      ? "slider-right hidden"
                      : "slider-right"
                  }
                />
                {/* {this.renderDots()} */}
              </div>
            </div>
          </div>
        </section>
      );
    }
  }
}

export default PromoSlider;
